export const TENANT_QUERY_PARAM = 'tenant';
export const TENANT_SWITCH_CHANNEL_NAME = 'tenant_switch_channel';
export const EXTERNAL_USER_ID_QUERY_PARAM = 'externalId';
